import { trackEvent } from 'utils/analytics';

export const getInitialState = () => ({
	selected: 'organizationType'
});

export const actions = {
	select: (state, id) => {
		trackEvent('Breakdown viz', 'Update', id);
		return {
			selected: id
		};
	}
};

export default {
	getInitialState,
	actions
};



// WEBPACK FOOTER //
// ./state/breakdown.js